// extracted by mini-css-extract-plugin
export default {"wrapper":"informationItem_wrapper__8SYJ+"};